import { render, staticRenderFns } from "./FinancialDre.vue?vue&type=template&id=368f2644&scoped=true"
import script from "./FinancialDre.vue?vue&type=script&lang=js"
export * from "./FinancialDre.vue?vue&type=script&lang=js"
import style0 from "./FinancialDre.vue?vue&type=style&index=0&id=368f2644&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "368f2644",
  null
  
)

export default component.exports